<template>
  <div id="app">
    <comment :is="layout">
      <router-view/>
    </comment>
  </div>
</template>
<script>
  import MainLayout from "./layouts/MainLayout";
  import EmptyLayout from "./layouts/EmptyLayout";

  export default {
    computed: {
      layout() {
        return (this.$route.meta.layout || "empty") + "-layout";
      }
    },
    components: {
      MainLayout,
      EmptyLayout
    },
    created() {
      if (localStorage.getItem("t") !== null && localStorage.getItem("rt")) {
        this.$store.commit("createTokens", {
          token: localStorage.getItem("t"),
          refresh_token: localStorage.getItem("rt")
        });
      }
    }
  };
</script>
<style>
  @import "https://unpkg.com/element-ui/lib/theme-chalk/index.css";
  @import "assets/elementUI.scss";
  @import "~materialize-css/dist/css/materialize.min.css";
  @import "assets/main.css";
</style>
